export default __webpack_public_path__ + "static/media/backArrow.a8a14a23.svg";